import { locale } from 'state';

const absolutePathRegex = /^(?:[a-z]+:)?\/\//i;

export default (link) => (
  absolutePathRegex.test(link) ? link : `/${locale()}${link}`
);
